/**
 * yumaSitoService — le conversazioni di Yuma sul sito yumaos.com, per la console (30/10/2026). Una sola porta del
 * server, `consoleYumaSito`, solo per il super utente: la storia del modello resta sul server, qui arrivano i messaggi
 * come li ha visti il visitatore. Forme dei dati in `shared/yuma-sito/tipi.ts`, le stesse del server e del sito.
 *
 * Logging: ogni chiamata registra in console azione, durata ed esito.
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import type { ConversazioneYumaPerLaConsole, ElencoConversazioniYuma, RigaConversazioneYuma, SpesaDiYuma } from '@shared/yuma-sito/tipi';

async function chiama<O>(dati: Record<string, unknown>): Promise<O> {
  const inizio = performance.now();
  try {
    const r = await httpsCallable<Record<string, unknown>, O>(functions, 'consoleYumaSito')(dati);
    console.info(`[yumaSito] ${String(dati.azione)} ok in ${Math.round(performance.now() - inizio)} ms`);
    return r.data;
  } catch (err) {
    console.error(`[yumaSito] ${String(dati.azione)} fallita dopo ${Math.round(performance.now() - inizio)} ms`, err);
    throw err;
  }
}

/** Una pagina dell'elenco, dalla più recente; `primaDi` = `aggiornata_il` dell'ultima riga già vista. */
export function leggiConversazioni(primaDi?: string): Promise<ElencoConversazioniYuma> {
  return chiama<ElencoConversazioniYuma>({ azione: 'elenco', ...(primaDi ? { prima_di: primaDi } : {}) });
}

export async function leggiConversazione(id: string): Promise<ConversazioneYumaPerLaConsole> {
  return (await chiama<{ conversazione: ConversazioneYumaPerLaConsole }>({ azione: 'conversazione', id })).conversazione;
}

/** Le conversazioni legate a un iscritto della lista d'attesa (dalla sua scheda). */
export async function conversazioniDellIscritto(leadId: string): Promise<RigaConversazioneYuma[]> {
  return (await chiama<{ conversazioni: RigaConversazioneYuma[] }>({ azione: 'per_iscritto', lead_id: leadId })).conversazioni;
}

/** Cambia il tetto di spesa del giorno e/o accende o spegne Yuma; il server rilegge e restituisce la spesa aggiornata. */
export async function impostaYumaSito(modifiche: { tetto_giornaliero_usd?: number; attiva?: boolean }): Promise<SpesaDiYuma> {
  return (await chiama<{ spesa: SpesaDiYuma }>({ azione: 'imposta', ...modifiche })).spesa;
}
